import * as React from 'react';
import { Balloon,Icon } from '@alifd/next';
import { useAppSelector } from '../../redux/hooks';
import './index.scss';

export default function Index ( props: any ) {
    const { quantityUnitStr,i18n, warehouseLeadTimeInfo, productIsMarketGoods } = props;
    if (!warehouseLeadTimeInfo) return null;
    const type = productIsMarketGoods? 'goods':'inquery';

    const skuInfo = useAppSelector(state => state.sku[type]);
    const { dispatchId } = skuInfo as any;

    const list = warehouseLeadTimeInfo[dispatchId] || warehouseLeadTimeInfo['DEFAULT'];

    if ( Array.isArray( list ) ) {
        const lastItem = list.slice( -1 );
        return (
            <div className="lead-time">
                <div className="lead-attr">
                    {i18n["marketAction.leadTime"]}
                    <Balloon trigger={<Icon type="prompt" size="small" />} align="tl" closable={false} triggerType="hover" style={{ width: 300 }}>
                        {i18n["detailModule.supplyAbility.tip"]}
                    </Balloon>
                </div>
                <div className="lead-list">
                    <table>
                        <tbody>
                            <tr>
                                <td>{`${i18n['undue_market_action.quantity']} (${quantityUnitStr})`}</td>
                                {list.map( ( item,index ) => (
                                    <td key={index}>{`${item.minQuantity} - ${item.maxQuantity}`}</td>
                                ) )}
                                <td> {`> ${lastItem[0].maxQuantity}`} </td>
                            </tr>
                            <tr>
                                <td>{i18n["detailModule.detailMarketPackage.EstTimeday"]}</td>
                                {list.map( ( item,index ) => (
                                    <td key={index}>{item.processPeriod}</td>
                                ) )}
                                <td>{i18n["rightAction.negotiated"]}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    } else {
        return null;
    }
}
